import React from 'react';
import clsx from 'clsx';
import DOMPurify from 'dompurify';
import styles from './index.scss';

export default function Label(props) {
  const { className, style, text, onClick } = props;
  const pureText = DOMPurify.sanitize(text);
  return (
    <div
      className={clsx(styles.label, 'label', className)}
      style={style}
      onClick={onClick}
      dangerouslySetInnerHTML={{
        __html: pureText,
      }}
    />
  );
}
